module.exports = __webpack_public_path__ + "img/02.神柏（杨树田-摄）.46090e3b.jpg";